import React from 'react';

const StraightLine = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="3" viewBox="0 0 40 3">
    <line
      id="Line_27"
      x1="40"
      transform="translate(0 1.5)"
      fill="none"
      stroke={props.stroke}
      strokeWidth="3"
    />
  </svg>
);
export default StraightLine;



// WEBPACK FOOTER //
// ./src/img/ComponentAsImage/StraightLine.js